module.exports = __webpack_public_path__ + "img/invoice-de-female-wm-banner-bb.3c6787fb.png";